import { useLoi } from '../../../hooks/useLoi';
import { loiTheoTruong } from '../../../lib/errors';

/**
 * Lỗi lưu không gắn được vào ô nào (503, 403, mạng…): hiện ngay trong hộp thoại, cạnh nút Lưu, thay cho
 * toast. Lỗi theo trường (`INVALID_ARGUMENT` có `errors`) thì form tự gắn dưới từng ô, ở đây bỏ qua.
 */
export function LoiForm({ loi }: { loi: unknown }) {
  const dichLoi = useLoi();
  if (!loi || Object.keys(loiTheoTruong(loi)).length > 0) return null;
  return (
    <p role="alert" className="rounded border border-danger-200 bg-danger-50 px-3 py-2 text-sm text-danger-700">
      {dichLoi(loi)}
    </p>
  );
}
